export const PageStateFlags = {
  RestoreEmployeesOverview: 'employees-overview-restore',
  RestoreTrainingGroupsOverview: 'training-groups-overview-restore',
  RestoreTrainingCategoriesOverview: 'training-categories-overview-restore',
  RestoreLearningPathsOverview: 'learning-paths-overview-restore',
  RestoreTextTemplatesOverview: 'text-templates-overview-restore',
  RestoreMarketingChannelsOverview: 'marketing-channels-overview-restore',
  RestoreStandardTrainingCategoriesOverview: 'standard-training-categories-overview-restore',
  RestoreComplianceCategoriesOverview: 'compliance-categories-overview-restore',
  RestoreCourseTemplatesOverview: 'course-templates-overview-restore',
  RestoreRegistrationLinksOverview: 'registration-links-overview-restore',
  RestoreTrainingTemplatesOverview: 'training-templates-overview-restore',
  RestoreMyTrainingsOverviewTable: 'my-trainings-overview-table-restore',
  RestoreTrainingsOverviewTable: 'trainings-overview-table-restore',
  RestoreOrganisationUnitsOverview: 'organisation-units-overview-restore',
  RestoreTrainingCatalogueOverview: 'training-catalogue-overview-restore',
  RestoreMyLearningPathsOverview: 'my-learning-paths-overview-restore',
};